import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6948229a&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=6948229a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports